
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(data=null) {
        const queryString = new URLSearchParams(data).toString();
        const url = `${API_URL}/models?${queryString}`; 

        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/models/${id}`, { headers: authHeader() });
    },
    createData(data) {

        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
        
        return axios.post(`${API_URL}/models`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/models/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/models/${id}`, { headers: authHeader() });
    },
    colors() {
        return axios.get(`${API_URL}/colors`, { headers: authHeader() });
    },
    sizes(id) {
        return axios.get(`${API_URL}/sizes/${id}`, { headers: authHeader() });
    },
    saveSize(data) {
        return axios.post(`${API_URL}/sizes`, data, { headers: authHeader() });
    },
    checkData(id, data){
        // Obtener el user_id desde el localStorage
        let userId = JSON.parse(localStorage.getItem('user'));

        // Validar el user_id
        if (!userId || !userId.id) {
            throw new Error("User ID no válido. Asegúrate de haber iniciado sesión.");
        }

        data.user_id = userId.id;
       return axios.patch(`${API_URL}/users-form/${id}`, data, { headers: authHeader() });
    },
    deleteForm(id) {
        return axios.delete(`${API_URL}/users-form/${id}`, { headers: authHeader() });
    },
};